"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  // Bag file version to write
  VERSION: '2.0',
  // Header field delimiter
  FIELD_DELIM: '=',
  OP_FIELD_NAME: 'op',
  TOPIC_FIELD_NAME: 'topic',
  VER_FIELD_NAME: 'ver',
  COUNT_FIELD_NAME: 'count',
  INDEX_POS_FIELD_NAME: 'index_pos',
  // 1.2+
  CONNECTION_COUNT_FIELD_NAME: 'conn_count',
  // 2.0+
  CHUNK_COUNT_FIELD_NAME: 'chunk_count',
  // 2.0+
  CONNECTION_FIELD_NAME: 'conn',
  // 2.0+
  COMPRESSION_FIELD_NAME: 'compression',
  // 2.0+
  SIZE_FIELD_NAME: 'size',
  // 2.0+
  TIME_FIELD_NAME: 'time',
  // 2.0+
  START_TIME_FIELD_NAME: 'start_time',
  // 2.0+
  END_TIME_FIELD_NAME: 'end_time',
  // 2.0+
  CHUNK_POS_FIELD_NAME: 'chunk_pos',
  // 2.0+
  ENCRYPTOR_FIELD_NAME: 'encryptor',
  // 2.0+
  // Legacy header fields
  MD5_FIELD_NAME: 'md5',
  // <2.0
  TYPE_FIELD_NAME: 'type',
  // <2.0
  DEF_FIELD_NAME: 'def',
  // <2.0
  SEC_FIELD_NAME: 'sec',
  // <2.0
  NSEC_FIELD_NAME: 'nsec',
  // <2.0
  LATCHING_FIELD_NAME: 'latching',
  // <2.0
  CALLERID_FIELD_NAME: 'callerid',
  // <2.0
  // Current "op" field values
  OP_MSG_DATA: 0x02,
  OP_FILE_HEADER: 0x03,
  OP_INDEX_DATA: 0x04,
  OP_CHUNK: 0x05,
  OP_CHUNK_INFO: 0x06,
  OP_CONNECTION: 0x07,
  // Legacy "op" field values
  OP_MSG_DEF: 0x01,
  // Bytes reserved for file header record (4KB)
  FILE_HEADER_LENGTH: 4 * 1024,
  // Index data record version to write
  INDEX_VERSION: 1,
  // Chunk info record version to write
  CHUNK_INFO_VERSION: 1,
  // Compression types
  COMPRESSION_NONE: 'none',
  COMPRESSION_BZ2: 'bz2',
  COMPRESSION_LZ4: 'lz4'
};
exports["default"] = _default;